import React, { MouseEvent } from 'react'
import classNames from 'classnames'
import { Icon, Paragraph, VisuallyHidden } from '@alto-avios/alto-ui'
import { CircleProps, StepStatus } from '../Stepper.types'
import styles from './StepperCircle.module.scss'

export const getStatus = (isCompleted: boolean, isSelected: boolean): StepStatus => {
  if (isCompleted) {
    return 'completed'
  }

  if (isSelected) {
    return 'selected'
  }

  return 'default'
}

function StepperCircle({ number, status, editable, selectStep, title, ...rest }: CircleProps) {
  const indexOffset = 1
  const selectableIndex = number - indexOffset
  const onSelectStep = (e: MouseEvent) => {
    e.preventDefault()

    if (!editable) {
      return
    }
    selectStep(selectableIndex)
  }

  return (
    <button
      className={classNames(styles.circle, styles[status])}
      type="button"
      onClick={onSelectStep}
      disabled={!editable}
      title={title}
      {...rest}
      data-testid="circle"
      tabIndex={editable ? 0 : -1}
    >
      {/* to do: change the check icon to be according to opco */}
      {status === 'completed' ? (
        <>
          <VisuallyHidden>{status}</VisuallyHidden>
          <Icon iconName="check" color="accentOnVibrant" />
        </>
      ) : (
        <Paragraph size="lg">{number}</Paragraph>
      )}
      <VisuallyHidden>{title}</VisuallyHidden>
    </button>
  )
}

export default StepperCircle
